import React, { useState, createRef, useCallback } from "react";
import Left from "../chevron-left.svg";

import ItemHistory from "./HistoryItem";

const History = ({
  list,
  toglebehavior,
  toggle,
  setgrouplink,
  removeSpecific,
  grouplinks,
  removeBulk
}) => {
  const ref = createRef();
  const [copied, setCopied] = useState("");
  const [zoom, setzoom] = useState(null);
  const [localFiles, setLocalFiles] = useState([]);
  const [showLocal, setShowLocal] = useState(false);
  const [activeZoom, setActiveZoom] = useState(-1);
  const [removeItems, setRemoveItems] = useState([])
  const [enableBulkRemove, setEnableBulkRemove] = useState(false)

  const copyUrl = (url) => {
    ref.current.value = `http://shot.screen1.me/${url}`;
    ref.current.select();
    document.execCommand("copy");
    ref.current.setSelectionRange(0, 99999);
    ref.current.focus();

    setCopied(url);
    setTimeout(() => {
      setCopied("");
    }, 2000);
  };

  const copyUrlGroup = (urls) => {
    ref.current.value = urls.replaceAll(".png", ".png\t\t");
    ref.current.select();
    document.execCommand("copy");
    ref.current.setSelectionRange(0, 99999);
    ref.current.focus();
  };

  const downloadList = () => {
    const element = document.createElement("a");
    const file = new Blob(
      [
        list
          .map((l) => "http://shot.screen1.me/" + l)
          .join(",")
          .replaceAll(",", "\n"),
      ],
      { type: "text/plain" }
    );
    element.href = URL.createObjectURL(file);
    element.download = "s3BW-links-" + Date.now() + ".txt";
    document.body.appendChild(element); // Required for this to work in FireFox
    element.click();
  };
  const loadLocalStorage = () => {
    const data = localStorage.getItem("files");

    if (data) {
      setLocalFiles(JSON.parse(data));
      setShowLocal(true)
    }
  };

  const clearLocalStorage = () => {
    localStorage.removeItem("files");
    setLocalFiles([]);
  };
  const evaluateRemove = (item) => {

    setRemoveItems(old => {
      return item.status == true ? [...old, item] : old.filter(o => o.key != item.key)
    })

  }
  const removeAll = () => {
    removeBulk(removeItems)
    setRemoveItems([])
  }
  return (
    <div className={toggle ? "story-class active" : "story-class"}>
      <div className="head">
        <label>Screenshots</label>

        {list && list.length > 0 &&  <button className="remove-bulk--btn" onClick={() => setEnableBulkRemove(old => {
          if (old == true) {
            setRemoveItems([])
          }
          return !old
        })}>{ enableBulkRemove ? 'Disable Bulk' : "Remove Bulk"}</button>}
        {removeItems.length > 0 && <button className="remove-bulk--btn" onClick={e => removeAll()}>Remove All</button>}
        <img
          className={!toggle ? "close" : ""}
          src={Left}
          width="15"
          alt=""
          onClick={() => toglebehavior(!toggle)}
        ></img>
      </div>

      <ul>
        {list?.map((value, index) => (
          <li key={index} style={{ background: activeZoom === value && '#4ea95d' }}>{
            <> {enableBulkRemove && (<div className="removeWrapper"><input type="checkbox" className="remove-bulk" checked={removeItems.some(i => i.key == value)} onChange={e => { evaluateRemove({ status: e.target.checked, key: value }) }}></input></div>)}
              <ItemHistory
                key={index}
                awskey={value}
                zoomIn={e => setzoom(e)}
                setActiveZoom={e => setActiveZoom(e)}
                removeSpecific={e => removeSpecific(e)}
                setgrouplink={e => setgrouplink(e)}
                copyUrl={e => copyUrl(e)}
                copied={copied}
              />
            </>
          }
          </li>
        ))}
      </ul>
      {list && list.length > 0 && (
        <div className="btn-container">
          {" "}
          <button
            className="addAll"
            width="100"
            onClick={() => {
              setgrouplink(
                list.map((key) => "http://shot.screen1.me/" + key).join("\n")
              );
              copyUrlGroup(
                list.map((key) => "http://shot.screen1.me/" + key).join("\n")
              );
            }}
          >
            Copy all
          </button>
          <button className="addAll" onClick={downloadList}>
            Download List
          </button>
        </div>
      )}
      <div className="localSection">
        <button className="addAll" onClick={() => loadLocalStorage()}>
          Load Storage
        </button>
        {localFiles.length > 0 && (
          <button className="addAll" onClick={() => clearLocalStorage()}>
            Remove Storage
          </button>
        )}
        <img
          className={!showLocal ? "btn close" : "btn"}
          alt=""
          src={Left}
          width="15"
          onClick={() => setShowLocal(!showLocal)}
        ></img>
        <ul>
          {localFiles && localFiles.map((value, index) => {
            return <li key={index} style={{ background: activeZoom === value && '#4ea95d' }}>{

              <ItemHistory

                key={index}
                awskey={value}
                zoomIn={e => setzoom(e)}
                setActiveZoom={e => setActiveZoom(e)}
                removeSpecific={e => removeSpecific(e)}
                setgrouplink={e => setgrouplink(e)}
                copyUrl={e => copyUrl(e)}
                copied={copied}
              />

            }</li>
          })}
        </ul>
      </div>
      <textarea ref={ref} type="text" style={{ opacity: 0 }}></textarea>

      {zoom && <ZoomViewer zoomImage={zoom} close={() => { setzoom(null); setActiveZoom(-1) }}></ZoomViewer>}
    </div>
  );
};
const ZoomViewer = (props) => {
  const { zoomImage: { src, link }, close } = props;

  // let {
  //   clientY,
  //   clientX,
  //   target: { src },
  // } = props;

  // const viewportHeight = window.innerHeight;
  // if (viewportHeight - viewportHeight / 3 < clientY)
  //   clientY = clientY - viewportHeight / 2;
  return (
    <div class="zoom-wrapper">
      <div className="overlay" onClick={e => close()}></div>
      <div className="content">
        <h2>{link}</h2>
        <img
          className="zoomed"
          alt=""
          src={src}
        ></img>
      </div>


    </div>
  );
};

export default History;
